import Api from './../ui/src/api';
import { getProp } from '../ui/src/utilities';

import { NotFoundError } from '../ui/src/errors';
import {
  addLoading,
  removeLoading,
  xhrRequest,
  xhrRequestSuccess,
  xhrRequestFailure,
  getSections,
  getSectionArticles,
} from '../ui/src/actions';
import {
  fetchSectionArticles,
  fetchArticleRelated,
  fetchArticles,
} from '../ui/src/csm.service';
import Cookies from 'js-cookie';
import moment from 'moment';

export const ACTION = {
  MAINMENU_REQUEST: 'MAINMENU_REQUEST',
  MAINMENU_SUCCESS: 'MAINMENU_SUCCESS',
  MAINMENU_FAILURE: 'MAINMENU_FAILURE',
  FOOTERMENU_REQUEST: 'FOOTERMENU_REQUEST',
  FOOTERMENU_SUCCESS: 'FOOTERMENU_SUCCESS',
  FOOTERMENU_FAILURE: 'FOOTERMENU_FAILURE',
  INFOMIX_ARTICLES_REQUEST: 'INFOMIX_ARTICLES_REQUEST',
  INFOMIX_ARTICLES_SUCCESS: 'INFOMIX_ARTICLES_SUCCESS',
  INFOMIX_ARTICLES_FAILURE: 'INFOMIX_ARTICLES_FAILURE',
  HOME_TRAFFIC_REQUEST: 'HOME_TRAFFIC_REQUEST',
  HOME_TRAFFIC_SUCCESS: 'HOME_TRAFFIC_SUCCESS',
  HOME_TRAFFIC_FAILURE: 'HOME_TRAFFIC_FAILURE',
  TRAFFIC_LIST_REQUEST: 'TRAFFIC_LIST_REQUEST',
  TRAFFIC_LIST_SUCCESS: 'TRAFFIC_LIST_SUCCESS',
  TRAFFIC_LIST_FAILURE: 'TRAFFIC_LIST_FAILURE',
  TRAFFIC_LIST_MORE_SUCCESS: 'TRAFFIC_LIST_MORE_SUCCESS',
  TRAFFIC_DETAIL_REQUEST: 'TRAFFIC_DETAIL_REQUEST',
  TRAFFIC_DETAIL_SUCCESS: 'TRAFFIC_DETAIL_SUCCESS',
  TRAFFIC_DETAIL_FAILURE: 'TRAFFIC_DETAIL_FAILURE',
  PLAYLIST_REQUEST: 'PLAYLIST_REQUEST',
  PLAYLIST_SUCCESS: 'PLAYLIST_SUCCESS',
  PLAYLIST_FAILURE: 'PLAYLIST_FAILURE',
  SECTION_DETAIL_REQUEST: 'SECTION_DETAIL_REQUEST',
  SECTION_DETAIL_SUCCESS: 'SECTION_DETAIL_SUCCESS',
  SECTION_DETAIL_MORE_ARTICLES_SUCCESS: 'SECTION_DETAIL_MORE_ARTICLES_SUCCESS',
  ARTICLE_DETAIL_REQUEST: 'ARTICLE_DETAIL_REQUEST',
  ARTICLE_DETAIL_SUCCESS: 'ARTICLE_DETAIL_SUCCESS',
  HOME_TVKOSICE_ARTICLE_REQUEST: 'HOME_TVKOSICE_ARTICLE_REQUEST',
  HOME_TVKOSICE_ARTICLE_SUCCESS: 'HOME_TVKOSICE_ARTICLE_SUCCESS',
  HOME_KOSICEONLINE_ARTICLE_REQUEST: 'HOME_KOSICEONLINE_ARTICLE_REQUEST',
  HOME_KOSICEONLINE_ARTICLE_SUCCESS: 'HOME_KOSICEONLINE_ARTICLE_SUCCESS',
  FEED_REQUEST: 'FEED_REQUEST',
  FEED_SUCCESS: 'FEED_SUCCESS',
  BANNER_FETCH_REQUEST: 'BANNER_FETCH_REQUEST',
  BANNER_FETCH_SUCCESS: 'BANNER_FETCH_SUCCESS',
  FETCH_CALENDAR_LOCATIONS_SUCCESS: 'FETCH_CALENDAR_LOCATIONS_SUCCESS',
  FETCH_CALENDAR_EVENTS_REQUEST: 'FETCH_CALENDAR_EVENTS_REQUEST',
  FETCH_CALENDAR_EVENTS_SUCCESS: 'FETCH_CALENDAR_EVENTS_SUCCESS',
  FETCH_CALENDAR_EVENTS_FAILURE: 'FETCH_CALENDAR_EVENTS_FAILURE',
  WEATHER_CREDIT: 'WEATHER_CREDIT',
};

export const fetchMainmenu = () => {
  return dispatch => {
    dispatch(xhrRequest('MAINMENU'));
    dispatch(addLoading());
    return Api.get(
      `/cm/public/${
        process.env.REACT_APP_CONTENT_SPACE
      }/sections/radiokosice-mainmenu/sections?treelevel=2`,
    )
      .then(response => {
        dispatch(removeLoading());
        dispatch(xhrRequestSuccess('MAINMENU', response));
        return response;
      })
      .catch(error => {
        dispatch(removeLoading());
        dispatch(xhrRequestFailure('MAINMENU'));
        throw error;
      });
  };
};

export const fetchFootermenu = () => {
  return getSections(
    process.env.REACT_APP_CONTENT_SPACE,
    'FOOTERMENU',
    'footer-menu',
  );
};

export const fetchInfomixArticles = () => {
  return getSectionArticles(
    process.env.REACT_APP_CONTENT_SPACE,
    'INFOMIX_ARTICLES',
    'infomix',
    {
      limit: 5,
    },
  );
};

export const fetchHomeTraffic = () => {
  const type = 'HOME_TRAFFIC';
  return (dispatch, getState) => {
    dispatch(xhrRequest(type));
    dispatch(addLoading());
    return Api.get('/traffic', {
      limit: 4,
    })
      .then(response => {
        dispatch(removeLoading());
        dispatch(
          xhrRequestSuccess(type, {
            items: getProp(response, 'traffic', []).map(item => item._id),
            nextOffset: getProp(response, 'nextOffset'),
          }),
        );
        dispatch({
          type: `TRAFFIC_DETAIL_SUCCESS`,
          data: getProp(response, 'traffic', []).map(item => {
            return {
              id: item._id,
              response: item,
            };
          }),
        });
      })
      .catch(error => {
        dispatch(removeLoading());
        dispatch(xhrRequestFailure(type));
        throw error;
      });
  };
};

export const fetchTraffic = params => {
  const type = 'TRAFFIC_LIST';
  return (dispatch, getState) => {
    dispatch(xhrRequest(type));
    dispatch(addLoading());
    return Api.get('/traffic', params)
      .then(response => {
        dispatch(removeLoading());
        let action = type;
        if ('offset' in params && params['offset'] > 0) {
          action = `${type}_MORE`;
        }
        dispatch(
          xhrRequestSuccess(action, {
            items: response.traffic.map(item => item._id),
            nextOffset: response.nextOffset,
          }),
        );
        dispatch({
          type: `TRAFFIC_DETAIL_SUCCESS`,
          data: response.traffic.map(item => {
            return {
              id: item._id,
              response: item,
            };
          }),
        });
      })
      .catch(error => {
        dispatch(removeLoading());
        dispatch(xhrRequestFailure(type));
        throw error;
      });
  };
};

export const getTrafficDetail = id => {
  const type = 'TRAFFIC_DETAIL';
  return (dispatch, getState) => {
    const trafficById = getState().trafficEntities.byId;
    if (id in trafficById) {
      return Promise.resolve();
    }
    dispatch(xhrRequest(type));
    dispatch(addLoading());
    return Api.get(`/traffic/${id}`)
      .then(response => {
        dispatch(removeLoading());
        dispatch({
          type: `${type}_SUCCESS`,
          data: [
            {
              id,
              response,
            },
          ],
        });
      })
      .catch(error => {
        dispatch(removeLoading());
        dispatch({
          type: `${type}_FAILURE`,
        });
        throw new NotFoundError();
      });
  };
};

export const fetchPlaylist = (params = {}) => {
  const type = 'PLAYLIST';
  return dispatch => {
    dispatch(xhrRequest(type));
    return Api.get(`/playlists/${process.env.REACT_APP_CONTENT_SPACE}`, params)
      .then(response => {
        dispatch(xhrRequestSuccess(type, response));
      })
      .catch(error => {
        dispatch(xhrRequestFailure(type));
        throw error;
      });
  };
};

export const fetchArticleDetail = id => {
  return dispatch => {
    dispatch(addLoading());
    dispatch({
      type: ACTION.ARTICLE_DETAIL_REQUEST,
    });

    fetchArticleRelated(process.env.REACT_APP_CONTENT_SPACE, id)
      .then(response => {
        dispatch({
          type: ACTION.ARTICLE_DETAIL_SUCCESS,
          data: {
            related: response.articles,
          },
        });
        dispatch(removeLoading());
      })
      .catch(e => {
        throw new NotFoundError();
      });
  };
};

export const fetchSectionDetail = id => {
  return dispatch => {
    const articleLimit = 8;
    dispatch(addLoading());
    dispatch({
      type: ACTION.SECTION_DETAIL_REQUEST,
    });
    return Promise.all([
      fetchSectionArticles(process.env.REACT_APP_CONTENT_SPACE, id, {
        limit: articleLimit,
      }),
    ])
      .then(responses => {
        let [articles] = responses;
        dispatch({
          type: ACTION.SECTION_DETAIL_SUCCESS,
          data: {
            articles,
          },
        });
        dispatch(removeLoading());
      })
      .catch(e => {
        dispatch(removeLoading());
        throw new NotFoundError();
      });
  };
};

export const fetchContentSpaceFeed = (
  cspace = null,
  articleLimit = 8,
  offset = 0,
  shouldConcat = false,
  extraParams = {}
) => {
  if (!cspace) {
    cspace = process.env.REACT_APP_CONTENT_SPACE;
  }
  return dispatch => {
    dispatch(addLoading());
    dispatch({
      type: ACTION.FEED_REQUEST,
    });
    return Promise.all([
      fetchArticles(cspace, {
        limit: articleLimit,
        offset: offset,
        ...extraParams
      }),
    ])
      .then(responses => {
        let [articles] = responses;
        dispatch({
          type: ACTION.FEED_SUCCESS,
          data: articles,
          shouldConcat
        });
        dispatch(removeLoading());
      })
      .catch(e => {
        dispatch(removeLoading());
        throw e;
      });
  };
};

export const loadMoreSectionDetailArticles = (id, offset) => {
  return dispatch => {
    const params = {
      offset,
      limit: 8,
    };
    fetchSectionArticles(process.env.REACT_APP_CONTENT_SPACE, id, params).then(
      response => {
        dispatch({
          type: ACTION.SECTION_DETAIL_MORE_ARTICLES_SUCCESS,
          data: {
            articles: response,
          },
        });
      },
    );
  };
};

export const getHomeArticleFromTvKosice = () => {
  return dispatch => {
    dispatch({
      type: ACTION.HOME_TVKOSICE_ARTICLE_REQUEST,
    });
    Api.get('/videos/home', {
      limit: 3,
    }).then(response => {
      let videos = getProp(response, 'videos', []);
      dispatch({
        type: ACTION.HOME_TVKOSICE_ARTICLE_SUCCESS,
        data: videos,
      });
    });
  };
};

export const getHomeArticleFromKosiceonline = () => {
  return dispatch => {
    dispatch({
      type: ACTION.HOME_KOSICEONLINE_ARTICLE_REQUEST,
    });
    Api.get('/cm/public/kosiceonline/articles', {
      limit: 3,
    }).then(response => {
      let articles = getProp(response, 'articles', []);      
      dispatch({
        type: ACTION.HOME_KOSICEONLINE_ARTICLE_SUCCESS,
        data: articles,
      });
    });
  };
};

export const fetchBanner = id => {
  return dispatch => {
    Api.get(`/cm/public/kosiceonline/banner/${id}`).then(response => {
      dispatch({
        type: ACTION.BANNER_FETCH_SUCCESS,
        data: {
          id: id,
          data: response,
        },
      });
    });
  };
};

export const updateWeatherCredit = credit => {
  return {
    type: ACTION.WEATHER_CREDIT,
    credit,
  };
};

export const getCalendarLocations = () => {
  return (dispatch, getState) => {
    const locations = getState().calendar.locations;
    if (locations.length > 0) {
      //return Promise.resolve();
    }
    return Api.get('/calendar/locations').then(response => {
      dispatch({
        type: ACTION.FETCH_CALENDAR_LOCATIONS_SUCCESS,
        data: response.locations,
      });
    });
  };
};

export const calendarEventsKey = (locationId, dateStr) => {
  return `${locationId}_${dateStr}`;
};

export const getCalendarEvents = (locationId, date) => {
  return dispatch => {
    const key = calendarEventsKey(locationId, date.format('YYYY-MM-DD'));
    dispatch(addLoading());
    dispatch({
      type: ACTION.FETCH_CALENDAR_EVENTS_REQUEST,
    });
    return Api.get(`/calendar/${locationId}/${date.format('YYYY-MM-DD')}`)
      .then(response => {
        dispatch(removeLoading());
        dispatch({
          type: ACTION.FETCH_CALENDAR_EVENTS_SUCCESS,
          data: {
            events: response.events,
            key,
          },
        });
      })
      .catch(err => {
        dispatch(removeLoading());
        dispatch({
          type: ACTION.FETCH_CALENDAR_EVENTS_FAILURE,
        });
      });
  };
};

export const getUser = token => {
  return dispatch => {
    const promises = [];
    promises.push(
      Api.get('/oauth2/user').then(response => {
        dispatch({
          type: ACTION.GET_USER,
          data: response,
        });
      }),
    );
    let lastvisit = Cookies.get('last_visit');
    const params = {};
    let since = moment(lastvisit);
    if (lastvisit && since.isValid()) {
      params['since'] = since;
    }
    promises.push(
      Api.get(
        `/cm/public/${process.env.REACT_APP_CONTENT_SPACE}/userfeed/count`,
        params,
      ).then(response => {
        dispatch({
          type: ACTION.UPDATE_UNREAD_ARTICLES,
          data: response.count,
        });
      }),
    );

    return Promise.all(promises);
  };
};

export const fetchStaticText = (cspace, key, textId) => {
  return dispatch => {
    dispatch(xhrRequest(key));
    dispatch(addLoading());
    return Api.get(`/cm/public/${cspace}/static-content/${textId}`)
      .then(response => {
        dispatch(removeLoading());
        dispatch(xhrRequestSuccess(key, response));
        return response;
      })
      .catch(error => {
        dispatch(removeLoading());
        dispatch(xhrRequestFailure(key));
        throw error;
      });
  };
}

export const fetchCalendarStaticText = () => {
  return dispatch => {
    dispatch(
      fetchStaticText(
        process.env.REACT_APP_CONTENT_SPACE,
        'CALENDAR_STATIC_TEXT',
        'reklamny-text-v-kalendari',
      ),
    );
  };
};



// WEBPACK FOOTER //
// ./src/app/actions.js